<template lang="html">
  <div id="rootsub">
  <div id="subscribe" v-if="company">
    <Form horizontal @submit.native.prevent="now++">
      <div class="zoom">
        <template v-if="now < 1">
          <h2>Benvenuto in</h2>
          <h1>
            <div v-if="`${$store.config.API_URL}/logo/${company.id}` != null">
            <img :src="`${$store.config.API_URL}/logo/${company.id}`" style="height: 60px; margin-right: 10px; width: auto; vertical-align: middle">
            </div>
            <div v-else>
              {{ company.name }}
            </div>
            
            <!--<img alt="😀" class="imga" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAC/VBMVEUAAAD/tlD/wUr/zEz/yUf/xUf/xEr/3lv/pCz/0U//0kv/sz7/xUn/4V//oin/xEr/xUn/sT7/vUL/3Fn/4Fz/xEr/xEn/1Er/sz3/z0b/qzX/1FD/41v/pSr/rTT/xEz/u0r/x0P/wk7/pCz/0kv/sj7/yED/qTH/pi7/wVD/1U//z0b/yEH/4F7/rzr/w07/oir/yj//2lb/qjP/zUT/uEX/rTj/4l//oCj/wk7/pCz/42D/oSn/x0X/xUn/xEj/zEP/uUf/2lf/v1D/x0P/317/oyn/pCv/4WL/nyj/vEj/00z/qzX/wVH/wVH/3Vn/tkP/x0X/tkP/x0X/vUz/vUz/2FH/11L/3lz/3l3/xkP/x0P/oCf/oCj/qzX/qzb/pS3/yEL/wFH/yED/yED/x0P/3lz/3l3/yEb/3Fj/21swLDv/xkf/yED/x0T/xUr/xEn/0Ej/yEL/1U7/w0z/////wk7/rDb/sDv/qTL/wVD/ykD/zEP/zUX/3lv/0kv/11L/vk3/2FT/2lb/oyv/21j/sj7/pi7/tEH/ukj/uEX/tkNZVmL/u0r9/v7/4F7uYVUzLjvzaV36+/z2+Pry9Pju8fbo6/Ph5vDb4e1XVGF1Xz+6kUVmVD7jTD5HPT1COTydfEBxVjyssL91cnxmZHBTUV9JRVP7vlDPnkndq0j2v0XrtkW1jUX9xUPFm0PcrUGsiEF4YEA+MD5YST1RRD03Lzu4kUGMbkGBZ0GGa0BwWj5gTj1dTDz4+frk5ObIyc6vrraWlZ+HiZh+fYl6d4FtanVjYGtVUl5QTl3uaFzkZFvdXFKmUlGeUFCUTU7qs0ySS0x9RUrirUm+k0iFQ0fJnEamf0ZqP0b6wkWphUQ6NkT+xkPXqUOWdkPmpkKjgEK3h0GPc0GUcEH3wkDJnkDBmUC9lj/PlT+ohj9zXj/loj2hdD3WST25RD2PPj34rTzPkjyrfDySajt6WztnTztfNDs8NDs7LDlHLThRLTbK0d/K0N7Dl0mpg0gAzpYFAAAAa3RSTlMAAwccCrifbWkW7+6soZ5pXywa65FTQjw7ODUwHRoTBf37+vr29evp5uXl5eXk5OPizs3Lwr+/u7qxsaqqoI+NhIKAbmtgXVNEQjYr/Oro5OTj4+LOzMLBtLOwo4+OiIB3dHJwb1dWVUU6DlvGqlEAAAQ4SURBVFjD1dZVlNpAFAbgG0qBuru7u7u7u7uXuru7U2+hApXt7nZd6u7u7u7uepoQkpGEzQBP/V44559770mYMAH+M+lrG5MnKFeqVLkEyY2104N34tRIUGAhoUCCGnHAQ7qerSeoatNLB+z0xkYT3EpWtS+wyWRMNj1GyYwcMEhXdKqmon1AC1d1CpPkmTT2u+UkRq1iQQzq5R3KLG86cCtN3KEeiJsK3EiVfaJHsruZVC/uYA/FVb27WPkGeyxfUpXHsPh4LxTngFZ5nFcqKzZsrJfSUA90kf5eKkLeXLf+XqtOnBs5vR+UUw9Il/4+6I6dh/npxcfP7C9ClT2hL+zPHtNhfnRm9hhCebrezAsPJNNAq5Cuf0pXpwBJbGrlicXstCYYT4PXiKnlCVXeVn5fZBlAuB1ldtmGx9ukNOo2WZ9FerckHkAKNUusePxSjkOphsQgakflIXLHHjzeI8chVEMFEDWh8jtyxy483iXHd6iGZq7zYwAleJ3UEYbHYVK6LpjuEM/v3v1o0tcaeQNPb0S6YpuiISUIqvdTCIsWGnZvJdOtu4U0OkxZnwgEFVGAeu7vfBiijEMe7ryPpiOVQFChn88MIIjv+6D44g/E90GxxUEDfSYOij/IZ+KtGdSWAgOu2m7at+8It75cw7Naw3dst9+0XQ0IVKs2iNs/EDcswHbXGrne7Nb6SOtdW8Awoknc/kR4FESOcD8uCO8SH8iUw5BLFqz4lt/xY5uObtx45MjGjUc3HTvudwtbtFzC2lKKP1osCRJq/DYdPnhg/769C4ZTFuzdt//AwcOb/ISqIKzN9aerEEpsfMWGVStXLF+2dMkC5aAFS5YuW75i5aoNfNll1FUIRAYU+fMVv7QH/ebL/FGXQTpqR8jOs1/RedSVWDr8s6KMP9MOaQ86xJ9uqCdrRnApg8Jwfj9ObN68mjdPhZBv3nyC39sdqKcMSFKg8LKZ0R/Ug16QujxjJFvWsc1Zt0VuyaMDWdcxsmtsg/6ijmqA6BugS4pimROFLqihHjDVJsv8LdpzLP6oPhHguOZoxa496BqqbsEBoW7m+bLtckP09XNnzl6MiLh49sy569FyvBPVZq4LlCqzkUdifcSFU4sFJ086P05diBDzR1hpFaBxJeYgD74JDVdOLyKcviKk3x5ghSU4UEjaeC5yz+H8Tr++e/tmrdObt+++Ondh1z2srGlSUJEk3izMc4dr977/+Pnzx3fXbjme4zXxkoCq1Dlm4F693mMh9nz361dEQY7U4EbaeKNI7z98/PTZ8eWL4/Onjx/eU4vx0Bzl3RUcxawgcV+0pCVHMiqZAWLEdarPNKcjB1rSFhutqVhaYMCZcsU8JpeJAzY6U+6ZbuXurAd2ulpls01Tka1sLR14KGPNhIXJKYUT1swI3slQx9Q+YfnSpcsn7GCqkwH+L/8AJOGcZsu/g9wAAAAASUVORK5CYII=">
          --></h1>
        </template>
        <template v-else>
          <h2>Benvenuto</h2>
          <h1>{{ form.first_name }}</h1>
        </template>
      </div>
      <div class="slides">

        <div v-for="(sl, sl_i) in slides" class="slide" :slide="sl.type">
          <div class="zoom" v-if="sl.type == 'first_name'">
            <FormItem label="Nome">
              <Input v-model="form.first_name" clearable required placeholder=""/>
            </FormItem>
            <FormItem label="Cognome">
              <Input v-model="form.last_name" clearable required placeholder=""/>
            </FormItem>
            <FormItem label="Telefono">
              <Input required v-model="form.telephone" placeholder="" style="-width: auto"/>
            </FormItem>
            <FormItem label="Email" v-if="ask_email">
              <Input required v-model="form.email" placeholder="" style="-width: auto"/>
            </FormItem>
          </div>

          <div class="zoom" v-else-if="sl.type == 'birth_date'">
            <FormItem label="Data di nascita">
              <FormItem horizontal>
                <Input required v-model="form.date_d" placeholder="GG" style="width: 50px" number/>
                &nbsp;
                <Input required v-model="form.date_m" placeholder="MM" style="width: 50px" number/>
                &nbsp;
                <Input required v-model="form.date_y" placeholder="AAAA" style="width: 100px" number/>
              </FormItem>
            </FormItem>

            <FormItem label="Città e provincia di nascita">
                <Input required v-model="form.birth_city" placeholder="es: Bologna" style="width: auto"/>
                &nbsp;
                <Input required v-model="form.birth_prov" placeholder="es: BO" style="width: 100px"/>
            </FormItem>
          </div>

          <div class="zoom" v-else-if="sl.type == 'doc'">
            <FormItem label="Codice fiscale">
              <Input required v-model="form.doc" placeholder="" style="width: auto"/>
            </FormItem>
          </div>

          <div class="zoom" v-else-if="sl.type == 'residence'">
            <FormItem label="Città e provincia di residenza">
              <Input required v-model="form.addr_zip" placeholder="CAP" style="width: 45px"/>
              &nbsp;
              <Input required v-model="form.addr_city" placeholder="Città" style="width: auto"/>
              &nbsp;
              <Input required v-model="form.addr_prov" placeholder="Provincia" style="width: 65px"/>
            </FormItem>
            <FormItem label="Indirizzo di residenza">
              <Input required v-model="form.addr_street" placeholder="es: Via Mascarella 41" />
            </FormItem>
          </div>

          <div class="zoom" v-else-if="sl.type == 'module'">
            <h2>Campi del Modulo</h2>

            <!-- <p>Prima di registrarsi è necessario prendere visione e accettare il modulo che trovi <a :href="`/moduli/${company.module.file_pdf}`" download="modulo-iscrizione.pdf">qui</a>.</p> -->


            <div v-for="field in company.module.fields" :key="field.name">
              <FormItem v-if="field.type == 'text'" :label="field.label">
                <Input required v-model="form.meta[field.name]" :placeholder="field.label"/>
              </FormItem>
              <FormItem v-if="field.type == 'check'">
                <Checkbox v-model="form.meta[field.name]" type="checkbox" size="large">
                  &nbsp;&nbsp;
                  {{ field.label }}
                </Checkbox>
              </FormItem>
            </div>
          </div>


          <div v-else-if="sl.type == 'signature'">
            <br>
            <div class="zoom">
              Quasi finito! Inserisci la tua firma nel riquadro:
            </div>

            <vueSignature v-if="now_delay == sl_i" ref="signature"
            style="border: 1px solid #666; margin: 20px auto; box-shadow: 0 0 50px rgba(0,0,0,.2)"
            :w="sign_wid" :h="sign_hei"
            :sigOption="{ penColor:'rgb(0, 0, 0)', backgroundColor:'rgb(255,255,255)' }"/>

            <div class="zoom">
              <a @click="show_privacy = true">visualizza informativa privacy</a>
              &nbsp;
              &nbsp;
              <Button @click.native="clearSig()">Pulisci firma</Button>
            </div>
          </div>

          <div v-else-if="sl.type == 'check-document'">
            <br>
            <div class="zoom">
              Prima di procedere, controlla che il modulo di iscrizione sia completo e accurato:
              <a href="#" @click.prevent="downloadPreview">Scarica anteprima modulo</a>
            </div>
          </div>

          <div class="zoom" v-else-if="sl.type == 'finish'">
            <br>
            <div v-if="saving">
              <h3>Salvataggio in corso...</h3>
            </div>

            <div v-if="!saving && saved">
              <h2>Registrazione completata!</h2>
              <br>
              <a @click="form={}; now=0">Torna all'inizio</a>
            </div>

            <div v-if="!saving && !saved">
              <h4>Errore durante la registrazione</h4>
              <a @click="now=0">Riprova</a>
              
            </div>
          </div>

          <FormItem v-if="sl_i == now" class="zoom">
            <FormItem>
              <Button type="error" @click="now--" v-if="!sl.hide_prev || !sl.hide_prev()" :disabled="sl.dis_prev && sl.dis_prev()">
                <Icon type="ios-arrow-left" style=""/>&nbsp;&nbsp;&nbsp;Indietro
              </Button>
              <Button html-type="submit" v-if="!sl.hide_next || !sl.hide_next()" :disabled="sl.dis_next && sl.dis_next()">
                Avanti
              </Button>
            </FormItem>
          </FormItem>
        </div>
      </div>
    </Form>
  </div>

  <Modal v-model="show_privacy" v-if="company">
    <br>
    <h2>Informativa privacy</h2>
    <br>
    <div v-if="company.privacy_policy" v-html="company.privacy_policy"/>
    <div v-else>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">La
                  seguente informativa, resa ai sensi dell’art. 13 del Regolamento
                  UE/2016/679, nonché del D.Lgs. 10/08/2018 n. 101 e dell’art. 13
                  del D.Lgs. 30/06/2003 n. 196, è finalizzata all’acquisizione del
                  consenso informato al trattamento dati. </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">1.
                  Il Titolare del trattamento dei dati da lei forniti è l’associazione
                  intestataria della presente domanda nella persona del legale
                  rappresentate Presidente </font>
              </font>
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt"><u>{{ company.legale_name }}</u></font>
              </font>
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">
                  facente funzione di Responsabile del trattamento, contattabile
                  all’indirizzo mail </font>
              </font>
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt"><u>{{ company.legale_email }}</u></font>
              </font>
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">.</font>
              </font>
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">
                </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">2.
                  I dati personali forniti verranno trattati - in virtù del consenso
                  da lei accordato - per la gestione del rapporto associativo e per
                  l’organizzazione delle attività associative. </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">3.
                  Il trattamento potrà riguardare anche dati personali rientranti nel
                  novero dei dati particolari o &quot;sensibili&quot;, vale a dire “i
                  dati personali idonei a rivelare l'origine razziale ed etnica, le
                  convinzioni religiose, filosofiche o di altro genere, le opinioni
                  politiche, l'adesione a partiti, sindacati, associazioni od
                  organizzazioni a carattere religioso, filosofico, politico o
                  sindacale, nonché i dati personali idonei a rivelare lo stato di
                  salute e la vita sessuale”. </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">4.
                  Il conferimento dei dati è obbligatorio per il raggiungimento delle
                  finalità dello statuto dell’Associazione ed è quindi
                  indispensabile per l’accoglimento della sua domanda di ammissione a
                  socio: l'eventuale rifiuto a fornirli comporta l'impossibilità di
                  accogliere la domanda di iscrizione e/o tesseramento, non essendo in
                  tale ipotesi possibile instaurare l’indicato rapporto associativo. </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Vrinda, serif">
          <font size="3" style="font-size: 12pt"><span style="background: transparent">
              <font face="Times New Roman, serif">
                <font size="2" style="font-size: 9pt">5.
                  I dati conferiti potranno essere comunicati alle Pubbliche
                  Amministrazioni nell’esercizio delle funzioni di legge ovvero nella
                  rendicontazione di servizi convenzionati o finanziati, all’Istituto
                  assicurativo per attivare le polizze nell’interesse del socio, a
                  cui l’associazione è affiliata ai fini del relativo tesseramento. </font>
              </font>
            </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span style="background: transparent">7.
              I dati anagrafici saranno conservati per dieci anni ai sensi del
              codice civile. La conservazione si rende necessaria per poter
              dimostrare la corretta gestione del rapporto associativo nel rispetto
              della normativa anche fiscale. </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span style="background: transparent">8.
              Il trattamento potrà avvenire su supporto cartaceo ed informatico,
              nel rispetto delle misure di sicurezza adottate dall’associazione. </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span style="background: transparent">9.
              In ogni momento Lei potrà esercitare i diritti di cui all’artt. 15
              – 20 del GDPR quali, a titolo esemplificativo, il diritto di
              accesso ai propri dati personali per aggiornarli/rettificarli o
              chiederne la cancellazione, il diritto di limitarne il trattamento
              revocando il consenso con riferimento a specifiche finalità
              perseguite o di opporsi al loro trattamento, oltre al diritto alla
              portabilità dei dati. Tali diritti possono essere esercitati
              attraverso specifica istanza da indirizzare tramite raccomandata -
              anche a mano o PEC - al Titolare del trattamento. Lei ha inoltre il
              diritto di proporre reclamo al Garante per la protezione dei dati
              personali. </span></font>
        </font>
      </p>
      <p align="justify" style="margin-bottom: 0in; line-height: 100%">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span style="background: transparent">10.
              L’associazione non attiva alcun processo decisionale automatizzato,
              né alcuna attività di profilazione. </span></font>
        </font>
      </p>
    </div>
  </Modal>
</div>
</template>

<script>
export default {
  data () {
    return {
      show_privacy: false,
      form: { meta: {} },
      now: -1,
      now_delay: -1,
      company: null,
      saved: false,
      saving: false,
      sig_ok: false,
    }
  },

  mounted () {
    this.$utils.setZoom(1)

    this.__int = setInterval(() => {
      let s = this._sig()
      this.sig_ok = s && !s.isEmpty()
      if (s) {
        this.form.signature_new = s.save()
      }
    }, 300)
  },

  beforeDestroy () {
    console.log('destr')
    clearInterval(this.__int)
    this.$utils.setZoom(this.$utils.getZoom())
  },

  computed: {
    ask_email() {
      return this.company.module && this.company.module.variables.includes('email')
    },
    slides () {
      let slides = []
      slides.push({ type: 'first_name',
          dis_next: () => {
            return !this.form.first_name || !this.form.last_name || !this.form.telephone || (this.ask_email && !(this.form.email+'').match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/))
          }
      })
      slides.push({ type: 'birth_date',
          dis_next: () => {
            let f = this.form
            return !(f.date_d >= 1
                && f.date_m >= 1
                && f.date_y >= 1900
                && f.date_d <= 31
                && f.date_m <= 12
                && f.date_y <= 2020
                && (f.birth_date = `${f.date_y}-${f.date_m}-${f.date_d}`))
                ||
                !f.birth_city || !f.birth_prov
          }
      })
      slides.push({ type: 'doc',
          // dis_next: () => {
          //   let f = this.form
          //   return !f.doc
          //   // || (f.doc.length > 10 && !this.$utils.is_cf(f.doc))
          // }
      })
      slides.push({ type: 'residence',
          dis_next: () => {
            let f = this.form
            return !f.addr_city || !f.addr_prov || !f.addr_zip
            || !f.addr_street
          }
      })
      if (this.company && this.company.module) {
        slides.push({ type: 'module',
          dis_next: () => {
            let is_valid = true
            this.company.module.fields.forEach(x => {
              let v = this.form.meta[x.name]
              if (x.required && (v === undefined || v === null || !String(v).length)) {
                is_valid = false
              }
            })
            return !is_valid
          }
        })
      }
      slides.push({ type: 'signature',
          dis_next: () => {
            return !this.sig_ok
          }
      })
      if (this.company && this.company.module) {
        slides.push({ type: 'check-document' })
      }
      slides.push({ type: 'finish',
          hide_next: () => true,
          hide_prev: () => true,
      })
      return slides
    },
    url_name () {
      return this.$route.params.name
    },
    cur_slide () {
      return this.slides[this.now]
    },
    sign_wid () {
      return Math.min(800, document.body.clientWidth-20)+'px'
    },
    sign_hei () {
      return Math.floor(Math.min(800, document.body.clientWidth-20) / 1.5)+'px'
    },
  },

  methods: {
    _sig() {
      let s = this.$refs.signature
      return s && s[0] && s[0].clear ? s[0] : (s && s.clear) ? s : null
    },
    style_slide (slide_name) {
      console.log('slide', slide_name)
      let slide_i = null
      this.slides.some((s, s_i) => {
        if (s.type == slide_name) {
          slide_i = s_i
          return true
        }
      })
      if (slide_i === null) throw 'shit no name ' + slide_name

      return {
        // 'margin-top': (this.slides.length-slide_i-1-this.now)*100+'%',
        opacity: slide_i == this.now ? 1 : 0,
        'z-index': slide_i == this.now ? 10 : 9,
      }
    },

    downloadPreview() {
      this.save(true)
    },
    save (is_preview) {
      this.saving = true
      this.form.company_id = this.company.id
      //this.form.fast_signup = true
      this.form.number = ('X-'+Math.random()).replace('0.', '').substring(0, 7)
      if (this.form.doc.length == 16) {
        this.form.cf = this.form.doc
      }

      this.form.preview = 0
      if (is_preview) {
        this.form._post = 1
        this.form.preview = true
        this.$utils.download('Anteprima modulo.docx', 'associates', this.form)
        return
      }
      this.form.flag=true
      this.$http.post('associates', this.form).then(res => {
        this.saved = true
      }, res => {
        this.saved = false
      }).finally(res => {
        this.saving = false
      })
    },

    clearSig () {
      this._sig().clear()
      // this.$refs.signature.clear()
    }
  },

  watch: {
    url_name: {
      immediate: true,
      handler(n) {
        console.log('asdf', n)
        this.$http.get(`resolve/${n}`).then(res => {
          this.company = res.data
          this.now = 4
          this.now = 0 // TODO
        })
      }
    },

    cur_slide (s) {
      if (s && s.type == 'finish') {
        this.save()
      }
      setTimeout(() => {

        document.querySelectorAll('.slide.active').forEach(s => {
          s.classList.remove('active')
        })
        if (!s) return
        console.log(s)
        document.querySelector(`.slide[slide=${s.type}]`).classList.add('active')
        let input = document.querySelector(`.slide[slide=${s.type}] input`)
        input && input.focus()
      })
    },

    now (now, old) {
      setTimeout(() => {
        this.now_delay = now
      })
    },

    'form.addr_zip' (zip) {
      if (!zip || zip.length != 5) return
      let f = this.form
      this.$http.get(`cap-info/${zip}`).then(res => {
        if (!res) return
        let info = res.data
        this.$set(f, 'addr_city', info.nome)
        this.$set(f, 'addr_prov', info.sigla)
      })
    }
    //   this.error = false
    //
    //   // Signup complete
    //   if (now == 6) {
    //     this.save()
    //   }
    //
    //   setTimeout(() => {
    //     this.$refs[`focus-${this.now}`] && this.$refs[`focus-${this.now}`].focus()
    //   }, 1)
    // }
  }
}
</script>

<style lang="scss">


@keyframes fadein{
    0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}

@-webkit-keyframes fadein{
    0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}
#rootsub {
  // overflow: hidden;
  width: 100%;

  .zoom {
    zoom: 1.3;
  }
  // transform: scale(2);
  // transform-origin: top left;
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  // background: #0f0;

  button {
    -webkit-animation: .5s fadein;
    animation: .5s fadein;
  }

  #subscribe {
    max-width: 100%;
    // overflow: hidden;
    // background: #f00;

    *:not(.ivu-icon) {
      font-family: 'Alegreya Sans SC', monospace;
      font-weight: bold;
    }
    .ivu-form-item-label {
      font-weight: bold!important;
      text-align: center;
      width: 100%;
    }
    img {
      height: 20px;
      margin-left: 20px;
    }
    // position: absolute;
    display: flex;
    flex-grow: 1;
    // background: #fff;
    top: 0;
    left: 0;
    // bottom: 0%;
    // overflow: hidden;
    width: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    text-align: center;
    // padding: 0 10%;
    justify-content: center;
    padding-top: 50px;


    .slides {
      position: relative;
      height: 300px;
      overflow: unset;
      max-width: 900px;
      margin: 0 auto;
    }

    form {
      width: 100%;
    }

    // background: #fff;

    .slide {
      background: #fff;
      box-shadow: 0 0 50px rgba(0,0,0,.1);
      // position: absolute;
      position: absolute;
      top: 20px;
      left: 0;
      right: 0;
      opacity: 0;
      z-index: 1;
      display: none;

      &.active {
        display: block;
        opacity: 1;
        z-index: 10;
      }

      .ivu-form-item {
        max-width: 400px;
        margin: 3px auto 10px;
      }
      .ivu-input-wrapper {
        max-width: 200px!important;
      }

      .ivu-input {
        text-align: center;
      }


      transition: opacity 1s ease-in-out;
      // box-shadow: 0 0 42px rgba(0,0,0,0.3);

    }
  }
}

@media (max-width: 768px) {
  body {
    background: #fff!important;
  }
  #rootsub {
    .zoom {
      zoom: 1;
    }

    #subscribe .slide {
      box-shadow: none!important;
    }

  }
}
</style>
